<template>
    <div>
        <v-select
            :disabled="!item.hasType"
            @input="updateOperator"
            :preselect-first="true"
            :options="item.operatorOptions"
            :value="item.operator"/>
    </div>
</template>

<script>
    import {vSelect} from '@/components/form';
    import QueryLine from '@/components/query2/query-line';

    export default {
        name: 'operator',
        components: {vSelect},
        props: {
            /**
             * @type {QueryLine}
             */
            item: QueryLine,
        },
        methods: {
            updateOperator(operator) {
                this.$emit('update', {operator});
            },
        },
    };
</script>
